// Módulo Vuex para gerenciar notificações
export default {
  namespaced: true,

  state: {
    consultationCanceledNotifications: [],
    currentNotificationIndex: -1
  },

  getters: {
    currentNotification(state) {
      if (state.currentNotificationIndex >= 0 &&
          state.consultationCanceledNotifications.length > state.currentNotificationIndex) {
        return state.consultationCanceledNotifications[state.currentNotificationIndex];
      }
      return null;
    },

    hasMoreNotifications(state) {
      return state.currentNotificationIndex < state.consultationCanceledNotifications.length - 1;
    },

    // Novo getter para obter todas as notificações
    allNotifications(state) {
      return state.consultationCanceledNotifications;
    }
  },

  mutations: {
    ADD_CONSULTATION_CANCELED(state, notification) {
      state.consultationCanceledNotifications.push(notification);
      // Se for a primeira notificação, definir o índice atual como 0
      if (state.currentNotificationIndex === -1 && state.consultationCanceledNotifications.length === 1) {
        state.currentNotificationIndex = 0;
      }
    },

    ADD_MULTIPLE_NOTIFICATIONS(state, notifications) {
      if (Array.isArray(notifications)) {
        state.consultationCanceledNotifications = [
          ...state.consultationCanceledNotifications,
          ...notifications
        ];

        // Se não houver notificação atual selecionada, selecionar a primeira
        if (state.currentNotificationIndex === -1 && state.consultationCanceledNotifications.length > 0) {
          state.currentNotificationIndex = 0;
        }
      }
    },

    NEXT_NOTIFICATION(state) {
      if (state.currentNotificationIndex < state.consultationCanceledNotifications.length - 1) {
        state.currentNotificationIndex++;
      }
    },

    REMOVE_CURRENT_NOTIFICATION(state) {
      if (state.currentNotificationIndex >= 0) {
        state.consultationCanceledNotifications.splice(state.currentNotificationIndex, 1);

        // Ajustar o índice se necessário
        if (state.consultationCanceledNotifications.length === 0) {
          state.currentNotificationIndex = -1;
        } else if (state.currentNotificationIndex >= state.consultationCanceledNotifications.length) {
          state.currentNotificationIndex = state.consultationCanceledNotifications.length - 1;
        }
      }
    },

    // Nova mutation para remover uma notificação específica
    REMOVE_NOTIFICATION(state, notification) {
      const index = state.consultationCanceledNotifications.findIndex(
        item => item.creditId === notification.creditId
      );

      if (index !== -1) {
        state.consultationCanceledNotifications.splice(index, 1);

        // Ajustar o índice atual se necessário
        if (state.consultationCanceledNotifications.length === 0) {
          state.currentNotificationIndex = -1;
        } else if (state.currentNotificationIndex >= state.consultationCanceledNotifications.length) {
          state.currentNotificationIndex = state.consultationCanceledNotifications.length - 1;
        }
      }
    },

    CLEAR_ALL_NOTIFICATIONS(state) {
      state.consultationCanceledNotifications = [];
      state.currentNotificationIndex = -1;
    }
  },

  actions: {
    addConsultationCanceledNotification({ commit }, notification) {
      // Verificar se é um array ou um objeto único
      if (Array.isArray(notification)) {
        commit('ADD_MULTIPLE_NOTIFICATIONS', notification);
      } else {
        commit('ADD_CONSULTATION_CANCELED', notification);
      }
    },

    nextNotification({ commit }) {
      commit('NEXT_NOTIFICATION');
    },

    removeCurrentNotification({ commit }) {
      commit('REMOVE_CURRENT_NOTIFICATION');
    },

    // Nova action para remover uma notificação específica
    removeNotification({ commit }, notification) {
      commit('REMOVE_NOTIFICATION', notification);
    },

    clearAllNotifications({ commit }) {
      commit('CLEAR_ALL_NOTIFICATIONS');
    }
  }
};
